import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { ventures } from "../data/ventures";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 mix-blend-normal">
      <div className="mx-auto flex max-w-[1500px] items-center justify-between px-5 py-4 md:px-10">
        <div className="rounded-full border border-bone/10 bg-ink/85 px-4 py-2 text-bone backdrop-blur-xl">
          <Logo />
        </div>
        <nav className="hidden items-center gap-1 rounded-full border border-bone/10 bg-ink/85 p-1.5 text-bone backdrop-blur-xl lg:flex">
          {ventures.map((v) => (
            <NavLink
              key={v.slug}
              to={`/ventures/${v.slug}`}
              data-testid={`nav-link-${v.slug}`}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 font-mono text-[12px] uppercase tracking-[0.14em] transition-colors duration-300 ${
                  isActive ? "bg-bone text-ink" : "text-bone/75 hover:bg-bone/10 hover:text-bone"
                }`
              }
            >
              {v.short}
            </NavLink>
          ))}
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-bone/10 bg-ink/85 text-bone backdrop-blur-xl lg:hidden"
          aria-label="Menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          data-testid="mobile-menu"
          className="mx-5 rounded-3xl border border-bone/10 bg-ink/95 p-6 text-bone backdrop-blur-xl lg:hidden"
        >
          <Link to="/" data-testid="mobile-nav-home" className="block py-3 font-display text-2xl font-extrabold uppercase">
            Home
          </Link>
          {ventures.map((v) => (
            <Link
              key={v.slug}
              to={`/ventures/${v.slug}`}
              data-testid={`mobile-nav-${v.slug}`}
              className="flex items-baseline justify-between border-t border-bone/10 py-3"
            >
              <span className="font-display text-2xl font-extrabold uppercase">{v.short}</span>
              <span className="font-mono text-xs uppercase tracking-[0.18em] text-bone/60">{v.kind}</span>
            </Link>
          ))}
        </motion.div>
      )}
    </header>
  );
};
